import * as agentChatPayload from "./agent-chat-payload.js";
import * as sendAgentMessageResponse from "./send-agent-message-response.js";
export const shapeName = 'TSChatResponse';
export const schema = {
    ...sendAgentMessageResponse.schema,
    properties: {
        ...sendAgentMessageResponse.schema.properties,
        output: {
            ...agentChatPayload.schema
        }
    }
};
export function createUserShapeSchema() {
    return sendAgentMessageResponse.createUserShapeSchema({
        properties: {
            output: {
                '@ref': agentChatPayload.shapeName
            }
        }
    });
}
